import React from "react";
import "./styles.css";
import { videosArray } from "../../constants/contents";
import WomanMediaImg from "../../assets/img/woman-media.png";

function YoutubeChannel() {
  return (
    <div className="youtube-channel">
      <div className="youtube-channel__intro">
        <h1>Disfruta de nuestro contenido en Youtube</h1>
        <img src={WomanMediaImg} alt="woman watching her computer" />
      </div>
      <div className="youtube-channel__videos">
        {videosArray.map((videoLink) => (
          <iframe
            title="tramyVideo"
            frameBorder="0"
            src={videoLink}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        ))}
      </div>
    </div>
  );
}

export default YoutubeChannel;
